import styled from "styled-components";
import PuffLoader from "react-spinners/PuffLoader";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Wrap>
      <PuffLoader color="#fa5963" />
      <div className="desc">
        <p>
          요청하신 페이지를 찾을 수 없습니다.
          <br /> 주소를 다시 한 번 확인해 주세요.
        </p>
      </div>
      <button
        onClick={() => {
          navigate(-1);
          setTimeout(() => {
            window.location.reload();
          }, 100);
        }}
      >
        뒤로가기
      </button>
    </Wrap>
  );
};

export default NotFound;
const Wrap = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .desc {
    font-size: 14px;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    line-height: 1.5;
    text-align: center;
  }

  button {
    margin-top: 20px;
    font-size: 14px;
    background-color: #fa5963;
  }
`;
